import * as React from 'react';
import * as TFF from '@tff/types/tff';
import { PricingDetailsTitle } from './PricingDetailsTitle';
import PricingDetailsTable from './PricingDetailsTable';

interface PricingDetailsCardProps {
  flightDetails: TFF.FlightDetails;
  midocoFlightDetails?: TFF.FlightDetails;
  serviceFeeTotalAmount?: number;
  servicePackageFee?: number;
  onDetailClick: () => void;
  retrieveDb?: TFF.BookedRetrieve;
  isNdcFlightOnlyBooking: boolean | undefined;
  isTTSBooking: boolean | undefined;
  totalBookingPrice: number;
}

const PricingDetailsCard: React.FC<PricingDetailsCardProps> = ({
  flightDetails,
  midocoFlightDetails,
  onDetailClick,
  serviceFeeTotalAmount,
  servicePackageFee,
  retrieveDb,
  isNdcFlightOnlyBooking,
  isTTSBooking,
  totalBookingPrice,
}) => {
  return (
    <div className="tff-pricing-details-card">
      <PricingDetailsTitle />
      <PricingDetailsTable
        flightDetails={flightDetails}
        midocoFlightDetails={midocoFlightDetails}
        onDetailClick={onDetailClick}
        serviceFeeTotalAmount={serviceFeeTotalAmount}
        servicePackageFee={servicePackageFee}
        retrieveDb={retrieveDb}
        isNdcFlightOnlyBooking={isNdcFlightOnlyBooking}
        isTTSBooking={isTTSBooking}
        totalBookingPrice={totalBookingPrice}
      />
    </div>
  );
};

export default PricingDetailsCard;
